import { render, staticRenderFns } from "./Consultations.vue?vue&type=template&id=5fc7c8e9&"
import script from "./Consultations.vue?vue&type=script&lang=js&"
export * from "./Consultations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc7c8e9')) {
      api.createRecord('5fc7c8e9', component.options)
    } else {
      api.reload('5fc7c8e9', component.options)
    }
    module.hot.accept("./Consultations.vue?vue&type=template&id=5fc7c8e9&", function () {
      api.rerender('5fc7c8e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pain008/Consultations.vue"
export default component.exports